'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { fetchFeaturedCallouts } from '../clients/ecosystemClient';
import * as ActionTypes from './ActionTypes';
import { maybeEarlyRequest } from '../utils/earlyRequests';
export const getFeaturedCallouts = () => dispatch => {
  const request = maybeEarlyRequest('self-serve-callouts', () => fetchFeaturedCallouts());
  dispatch({
    type: ActionTypes.FEATURED_CALLOUTS_REQUESTED
  });
  return request.then(callouts => {
    const mappedCallouts = callouts.map((_ref) => {
      let {
        id: calloutId,
        publishedListing = {}
      } = _ref,
          rest = _objectWithoutPropertiesLoose(_ref, ["id", "publishedListing"]);

      return Object.assign({
        calloutId
      }, rest, {}, publishedListing);
    });
    dispatch({
      type: ActionTypes.FEATURED_CALLOUTS_RECEIVED,
      payload: mappedCallouts
    });
    return mappedCallouts;
  }).catch(error => {
    dispatch({
      type: ActionTypes.FEATURED_CALLOUTS_FAILED,
      payload: error
    });
    throw error;
  });
};